module.exports = __webpack_public_path__ + "static/media/ab_logo_icon.f1b27551.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ab_logo_icon.svg
// module id = 962
// module chunks = 0